import { render, staticRenderFns } from "./o-icon.vue?vue&type=template&id=9c3100b4&scoped=true"
import script from "./o-icon.js?vue&type=script&lang=js&external"
export * from "./o-icon.js?vue&type=script&lang=js&external"
import style0 from "./o-icon.scss?vue&type=style&index=0&id=9c3100b4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3100b4",
  null
  
)

export default component.exports